import { zfComponentThemeOverrides } from './zfComponentThemeOverrides';
import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const zfDark = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      banner: {
        info: '#34548a',
        error: '#8c4351',
        text: '#343b58',
        link: '#565a6e',
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#004D7A'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#004D7A'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#004D7A'], shape: shapes.wave }),
    service: genPageTheme({
      colors: ['#004D7A'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#004D7A'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#004D7A'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#004D7A'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#004D7A'], shape: shapes.wave }),
  },
  components: zfComponentThemeOverrides,
});
